import React from 'react';
import { Tile } from '../../../types';
import HeaderDropdownTile from '../../header-navigation-desktop/menu-dropdown/header-menu-tile';

interface TilesSectionProps {
  tiles: Tile[];
  className?: string;
}

export const TilesSection: React.FC<TilesSectionProps> = ({
  tiles,
  className = 'mt-20 flex justify-between gap-2',
}) => {
  if (!tiles || tiles.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {tiles.map((tile, index) => (
        <HeaderDropdownTile key={`${tile.tileCategoryKey}-${index}`} tileContent={tile} />
      ))}
    </div>
  );
};
